import Vue from 'vue'
import Router from 'vue-router'

import NewOrder from "@/components/NewOrder.vue";

import Login from '@/components/Login.vue'

import AdminOrder from "@/components/AdminOrder.vue";
import AdminMember from "@/components/AdminMember.vue";
import AdminEditor from "@/components/AdminEditor.vue";
import AdminReport from "@/components/AdminReport.vue";

import EditorOrder from "@/components/EditorOrder.vue";
import EditorMember from "@/components/EditorMember.vue";
import EditorReport from "@/components/EditorReport.vue";

import MemberOrder from "@/components/MemberOrder.vue";
import MemberReport from "@/components/MemberReport.vue";

import Profile from "@/components/Profile.vue";

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin/neworder',
      name: 'AdminNewOrder',
      component: NewOrder
    },
    {
      path: '/admin/order',
      name: 'AdminOrder',
      component: AdminOrder
    },
    {
      path: '/admin/member',
      name: 'AdminMember',
      component: AdminMember
    },
    {
      path: '/admin/editor',
      name: 'AdminEditor',
      component: AdminEditor
    },
    {
      path: '/admin/report',
      name: 'AdminReport',
      component: AdminReport
    },
    {
      path: '/editor/neworder',
      name: 'EditorNewOrder',
      component: NewOrder
    },
    {
      path: '/editor/order',
      name: 'EditorOrder',
      component: EditorOrder
    },
    {
      path: '/editor/member',
      name: 'EditorMember',
      component: EditorMember
    },
    {
      path: '/editor/report',
      name: 'EditorReport',
      component: EditorReport
    },
    {
      path: '/member/neworder',
      name: 'MemberNewOrder',
      component: NewOrder
    },
    {
      path: '/member/order',
      name: 'MemberOrder',
      component: MemberOrder
    },
    {
      path: '/member/report',
      name: 'MemberReport',
      component: MemberReport
    },

    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js